var map = {
	"./analysis.js": "swh5",
	"./dataV.js": "mem4",
	"./educationalTraining.js": "j9Kv",
	"./emergency.js": "xI/v",
	"./enterpriseManagement.js": "DOow",
	"./hiddenCheck.js": "+1yJ",
	"./home.js": "W27U",
	"./insurance.js": "09T9",
	"./riskManagement.js": "PNXc",
	"./riskWork.js": "WYls",
	"./setting.js": "cBLO",
	"./standardization.js": "cNfL",
	"./supervisionCheck.js": "LBnT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kyiS";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules \.js$
// module id = kyiS
// module chunks = 155